<template>
	<div class="search-filter">
		<slot></slot>
	</div>
</template>
<script>
export default {
	name: 'search-filter-wrapper'
}
</script>
<style lang="scss" scoped>
.search-filter {
	margin: 12px 0;
	border: 1px solid var(--primary-color);
	padding: 24px 0 0 24px;
	background-color: #ffffff;
	border-radius: 10px;
}
</style>
